module.exports = __webpack_public_path__ + "img/复制.1f426523.svg";